import React, { useState } from "react";
import { InfiniteScroll, Toast } from 'antd-mobile';
import ListOrderView from "./ListOrderView";
import api from "../../../api";

const ListOrder = (props) => {
  const limit = 5;

  const [orderList, setOrderList] = useState([])
  const [hasMore, setHasMore] = useState(true)
  const [params, setParams] = useState({ limit })


  // 加载订单列表
  // https://mobile.ant.design/zh/components/infinite-scroll#%E5%B1%9E%E6%80%A7
  const loadMore = async () => {
    const resp = await api.userOrderList(params);
    const orderListData = resp.data;

    if (!orderListData) {
      setHasMore(false)
      Toast.show({ content: '加载订单列表出错，请稍后再试' })
      return
    }

    if (orderListData.code !== 0) {
      setHasMore(false)
      Toast.show({ content: orderListData.message })
      return
    }

    const list = orderListData.data;
    if (list.length === 0) {
      setHasMore(false)
      return
    }

    let lastId = Number.MAX_VALUE;
    list.forEach(element => {
      if (element.id < lastId) {
        lastId = element.id
      }
    });
    setParams({ lastId, limit })
    setOrderList(val => [...val, ...list])
  }


  return (
    <>
      {
        orderList.map((item, index) => (
          <ListOrderView order={item} canClick={true} key={index} />
        ))
      }

      <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
    </>
  )
}

export default ListOrder